import React from "react";
import { Link } from "react-router-dom";
import Baskan from "./baskanHomePage/Baskan";
import QuickContact from "../../components/quickContack/QuickContact";
import SearchBox from "../../component/SearchBox";
import SerdivanAsistan from "../../components/chatbot/SerdivanAsistan";
import "./HeroSlide.css"; // We'll create this file for the consolidated styles

// Asistan yayına alınmadan önce sınırlı TEST erişimi için gizli anahtar.
// Ekip şu linkle açar (tarayıcıya kaydolur, kalıcı): serdivan.bel.tr/?asistan=bilgiislem
// Kapatmak için: serdivan.bel.tr/?asistan=kapat
const ASISTAN_TEST_KEY = "bilgiislem";

const HeroSlide = ({ activeIndex }) => {
  // Geliştirici modda (npm run dev) her zaman açık; canlıda yalnız gizli anahtarı bilenlerde.
  const [showAsistan] = React.useState(() => {
    if (import.meta.env.DEV) return true;
    try {
      const q = new URLSearchParams(window.location.search).get("asistan");
      if (q === ASISTAN_TEST_KEY || q === "ac") { localStorage.setItem("sa-beta", "1"); return true; }
      if (q === "kapat" || q === "0") { localStorage.removeItem("sa-beta"); return false; }
      return localStorage.getItem("sa-beta") === "1";
    } catch (e) { return false; }
  });

  return (
    <div
      className="hero-slide-container"
      style={{
        position: "relative",
        width: "100%",
        minHeight: "calc(var(--app-vh, 1vh) * 100)",
        height: "calc(var(--app-vh, 1vh) * 100)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        overscrollBehavior: "contain", // <-- scroll taşmasını engelle
      }}
    >
      {/* Hero Section - Background */}
      <section
        className="hero"
        style={{
          position: "relative",
          width: "100%",
          flex: 1,
          paddingTop: "90px",
          boxSizing: "border-box",
        }}
      >
        <div className="hero-content animate__animated animate__fadeInDown">
          <h1>Hoş Geldiniz</h1>
          <p>
            Serdivan Belediyesi'nin resmi web sitesine hoş geldiniz.
            Hizmetlerimize kolayca ulaşın.
          </p>
          
          {/* SearchBox - Below welcome text */}
          <div>
            <SearchBox />
          </div>

          {/* Hızlı Erişim Butonları */}
          <div
            className="quick-actions"
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "12px",
              marginTop: "18px",
              justifyContent: "center",
            }}
          >
            {/* Mobilde grid için ek class */}
            <div
              className="quick-actions-grid"
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "12px",
                width: "100%",
                maxWidth: "600px",
              }}
            >
              <a
                href="https://webportal.serdivan.bel.tr/"
                className="action-button"
                target="_blank"
                rel="noopener noreferrer"
                style={{ width: "100%" }}
              >
                Hızlı Ödeme
              </a>
              <Link to="/onlineislemler" className="action-button" style={{ width: "100%" }}>
                Online İşlemler
              </Link>
              <Link to="/hizmetlerimiz" className="action-button" style={{ width: "100%" }}>
                Hizmetlerimiz
              </Link>
              <Link to="/haberler" className="action-button" style={{ width: "100%" }}>
                Haberler
              </Link>
              <Link to="/iletisim" className="action-button" style={{ width: "100%" }}>
                İletişim
              </Link>
            </div>
          </div>
        </div>
      </section>

      {activeIndex === 0 && (
        <div
          className="hero-slide-extras"
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            pointerEvents: "none",
            position: "absolute",
            left: 0,
            bottom: 0,
          }}
        >
          <div style={{ width: "100%", pointerEvents: "auto"}}>
            <Baskan />
          </div>
          <div style={{ width: "100%", pointerEvents: "auto"}}>
            <QuickContact />
          </div>
        </div>
      )}

      {/* Serdivan+ Asistan — dev'de + canlıda yalnız gizli test anahtarını bilenlerde */}
      {showAsistan && <SerdivanAsistan />}
    </div>
  );
};

export default HeroSlide;